import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import Index from './pages/index';
import IndexThree from './pages/index/index-three';
import IndexFour from './pages/index/index-four';
import IndexTwo from './pages/index/index-two';
import IndexFive from './pages/index/index-five';
import IndexSix from './pages/index/index-six';
import IndexSeven from './pages/index/index-seven';
import IndexEight from './pages/index/index-eight';
import IndexNine from './pages/index/index-nine';
import IndexTen from './pages/index/index-ten';
import IndexEleven from './pages/index/index-eleven';
import Video from './pages/index/video';
import Map from './pages/index/map';
import ListLayoutOne from './pages/property/list-layout-one';
import ListLayoutTwo from './pages/property/list-layout-two';
import ScrollToTop from './components/scroll-to-top';
import ListLayoutThree from './pages/property/list-layout-three';
import ListLayoutWithMap from './pages/property/list-layout-with-map';
import ListLayoutFull from './pages/property/list-layout-full';
import GridLayoutWithSidebar from './pages/property/grid-layout-with-sidebar';
import ClassicalLayoutWithSidebar from './pages/property/classical-layout-with-sidebar';
import GridLayoutWithMap from './pages/property/grid-layout-with-map';
import Grid from './pages/property/grid';
import ClassicalProperty from './pages/property/classical-property';
import ClassicalLayoutWithMap from './pages/property/classical-layout-with-map';
import HalfMap from './pages/property/half-map';
import HalfMapTwo from './pages/property/half-map-2';
import SinglePropertyOne from './pages/property/single-property-1';
// single-property-2/3/4 removed — all redirect to single-property-1
import Agents from './pages/agents/agents';
import AgentPage from './pages/agents/agent-page';
import Agencies from './pages/agents/agencies';
import AgencyPage from './pages/agents/agency-page';
import AddAgent from './pages/agents/add-agent';
import AddInm from './pages/agents/add-inm';
import AddAso from './pages/agents/add-aso';
import SubmitProject from './pages/property/submit-project';
import Dashboard from './pages/admin/dashboard';
import Payment from './pages/admin/payment';
import MyProfile from './pages/admin/my-profile';
import MyProperty from './pages/admin/my-property';
import BookmarkList from './pages/admin/bookmark-list';
import ChangePassword from './pages/admin/change-password';
import CompareProperty from './pages/property/compare-property';
import SubmitProperty from './pages/property/submit-property-NUEVO';
import Blog from './pages/blog/blog';
import BlogDetail from './pages/blog/blog-detail';
import Component from './pages/component';
import Pricing from './pages/pricing';
import Error from './pages/error';
import Contact from './pages/contact';
import AboutUs from './pages/about-us';
import Checkout from './pages/admin/checkout';
import CreateAccount from './pages/admin/create-account';
import EditAgent from './pages/agents/edit-agent';
import Faq from './pages/faq';
import Beneficios from './pages/beneficios/Beneficios';
import Zonas from './pages/zonas/Zonas';
import ZonaDetail from './pages/zonas/ZonaDetail';
import Certificacion from './pages/certificacion/Certificacion';
import SubmitPropertyDashboard from './pages/admin/submit-property-dashboard';
import TestFirebase from './components/TestFirebase';
import FirebaseStorageTest from './components/FirebaseStorageTest';
import AMPIMigration from './components/AMPIMigration';
import AMPIMigrationOptimized from './components/AMPIMigrationOptimized';
import MigracionOptimizada from './components/MigracionOptimizada';
import CorreccionPropiedades from './components/CorreccionPropiedades';
import AnalizarGruposPropiedades from './components/AnalizarGruposPropiedades';
import EliminarPropiedadesDuplicadas from './components/EliminarPropiedadesDuplicadas';
import AgregarCampoTipo from './components/AgregarCampoTipo';
import DatabaseAnalysis from './components/DatabaseAnalysis';
import DatabaseCleanup from './components/DatabaseCleanup';
import IntegrityValidator from './components/IntegrityValidator';
import MigrationResume from './components/MigrationResume';
import PropertyDataChecker from './components/PropertyDataChecker';
import PropertyLinker from './components/PropertyLinker';
import PasswordResetManager from './components/PasswordResetManager';
import PropertyAssignmentManager from './components/PropertyAssignmentManager';
import DataSyncAnalyzer from './components/DataSyncAnalyzer';
import PropertyAnalyzer from './components/PropertyAnalyzer';
import FixFirebaseAccounts from './pages/admin/fix-firebase-accounts';
import FixFirebaseAccountsBatch from './pages/admin/fix-firebase-accounts-batch';
import FixMissingFirestoreUsers from './pages/admin/fix-missing-firestore-users';
import AsignarPropiedadesMiriam from './pages/admin/asignar-propiedades-miriam';
import AsignacionMasivaPropiedades from './pages/admin/asignacion-masiva-propiedades';
import DiagnosticoPropiedades from './pages/admin/diagnostico-propiedades';
import ActualizarNombresFlex from './pages/admin/actualizar-nombres-flex';
import ReporteAsignaciones from './pages/admin/reporte-asignaciones';
import PropertyCleanupManager from './pages/admin/property-cleanup-manager';
import PropertyManualLinker from './pages/admin/property-manual-linker';
import PropertyAgencyAssignerPage from './pages/admin/property-agency-assigner';
// import MigrationAudit from './components/MigrationAudit';
import CreateTaller from './pages/admin/create-taller';
import Calificacion from './pages/agents/calificacion';
import ClientOne from './components/client-one';
import Asociados from '../src/pages/agents/asociados';
import { UserProvider } from './context/UserContext';
import { ToastContainer } from 'react-toastify';
import AsociadoPage from './pages/agents/asociado-page';
import EditInmobiliaria from './pages/admin/editar-inm';
import 'react-toastify/dist/ReactToastify.css';
import './assets/css/navigation-fixes.css';
import VerTalleres from './pages/admin/ver-taller';
import AdminTalleres from './pages/admin/admin-talleres';
import PrivateRoute from './pages/admin/privateroute';
import EditTaller from './pages/admin/edit-taller';
import ProjectList from './pages/agents/project-list'
import VerTallerInd from './pages/admin/ver-taller-individual';
import ViewProject from './pages/agents/view-project';
import { Link } from 'react-router-dom';
import MyProject from './pages/admin/my-project';
import ViewProperty from './pages/admin/view-property';
import AprobarPropiedades from './pages/admin/aprobar-propiedades';
import MisCursos from './pages/admin/mis-cursos';
import ScannAsistenia from './pages/admin/escanear-asistencia';
import AdminDashboard from './pages/admin/admin-dashboard';
import AprobarResena from './pages/admin/aprobar-resena';
import AdminInm from './pages/admin/admin-inm';
import VerInm from './pages/admin/ver-inm';
import AddAdmin from './pages/admin/add-admin';
import AdminProject from './pages/admin/admin-project';
import VerProject from './pages/admin/ver-project';
import EditProject from './pages/admin/edit-project';
import AdminProperty from './pages/admin/admin-property';
import ViewAdminProperty from './pages/admin/view-admin-property';
import EditProperty from './pages/admin/edit-property-NUEVO';
import AdminAfiliado from './pages/admin/admin-afiliado';
import VerAdminAfiliado from './pages/admin/ver-admin-afiliado';
import EditarAfiliado from './pages/admin/editar-afiliado';
import VerAdminAsociado from './pages/admin/ver-admin-asociado';
import AdminAsociado from './pages/admin/admin-asociado';
import EditarAsociado from './pages/admin/editar-asociado';
import AdminAsignaciones from './pages/admin/admin-asignaciones';
import InscripcionCurso from './pages/admin/ins-taller';
import InscripcionCursoPublico from './pages/agents/inscripcion-publica';
import SeleccionarRol from './pages/admin/seleccionar-rol';
import AdminComiteDashboard from './pages/admin/admin-comite-dashboard';
import VerificarInmobiliariasNuevas from './pages/admin/verificar-inmobiliarias-nuevas';
import MigrarNuevosMiembros from './pages/admin/migrar-nuevos-miembros';
import PadronMiembrosOficiales from './pages/admin/padron-miembros-oficiales';
import ListaOficialMiembros from './pages/admin/lista-oficial-miembros';
import ReconciliarMiembros from './pages/admin/reconciliar-miembros';
import ReconciliarAgenciasCsv from './pages/admin/reconciliar-agencias-csv';
import LimpiarDuplicados from './pages/admin/limpiar-duplicados';
import ReubicarMiembros from './pages/admin/reubicar-miembros';
import MisLeads from './pages/admin/mis-leads';
import MLSSyncDashboard from './pages/admin/mls-sync-dashboard';
import ErrorBoundary from './components/error-boundary';

// Centro de Ayuda
import HelpCenter from './pages/help/HelpCenter';
import HelpSection from './pages/help/HelpSection';
import HelpArticle from './pages/help/HelpArticle';
import HelpFAQ from './pages/help/HelpFAQ';
import HelpGlossary from './pages/help/HelpGlossary';

function App() {
  return (

    <>
      <ErrorBoundary>
      <UserProvider>
      {/* Sprint 7 (F7-005): skip link para navegación con teclado (WCAG 2.4.1). */}
      <a href="#main-content" className="skip-to-main">Saltar al contenido principal</a>
      <ToastContainer /> {/* ✅ Aquí va, fuera de Routes */}
      <main id="main-content">
      <Routes>
        <Route path='/' element={<Index/>}/>
        {/* Sprint 6 (F0-008, F1-018): homepages variantes del template Resido.
            En producción redirigen a / (canonical única). En dev siguen accesibles para referencia. */}
        {process.env.NODE_ENV === 'development' ? (
          <>
            <Route path='/home-2' element={<IndexTwo/>}/>
            <Route path='/home-3' element={<IndexThree/>}/>
            <Route path='/home-4' element={<IndexFour/>}/>
            <Route path='/home-5' element={<IndexFive/>}/>
            <Route path='/home-6' element={<IndexSix/>}/>
            <Route path='/home-7' element={<IndexSeven/>}/>
            <Route path='/home-8' element={<IndexEight/>}/>
            <Route path='/home-9' element={<IndexNine/>}/>
            <Route path='/home-10' element={<IndexTen/>}/>
            <Route path='/home-11' element={<IndexEleven/>}/>
          </>
        ) : (
          <>
            <Route path='/home-2' element={<Navigate to='/' replace />}/>
            <Route path='/home-3' element={<Navigate to='/' replace />}/>
            <Route path='/home-4' element={<Navigate to='/' replace />}/>
            <Route path='/home-5' element={<Navigate to='/' replace />}/>
            <Route path='/home-6' element={<Navigate to='/' replace />}/>
            <Route path='/home-7' element={<Navigate to='/' replace />}/>
            <Route path='/home-8' element={<Navigate to='/' replace />}/>
            <Route path='/home-9' element={<Navigate to='/' replace />}/>
            <Route path='/home-10' element={<Navigate to='/' replace />}/>
            <Route path='/home-11' element={<Navigate to='/' replace />}/>
          </>
        )}
        <Route path='/video' element={<Video/>}/>
        <Route path='/map' element={<Map/>}/>
        {/* Sprint 0 (F0-001, F0-006): rutas de debug y herramientas destructivas
            requieren PrivateRoute ADMIN. Las de test solo deberían estar activas en desarrollo. */}
        <Route path='/firebase-test' element={<PrivateRoute roles={['ADMIN']} showError={true}><TestFirebase /></PrivateRoute>} />
        <Route path='/storage-test' element={<PrivateRoute roles={['ADMIN']} showError={true}><FirebaseStorageTest /></PrivateRoute>} />
        <Route path='/ampi-migration' element={<PrivateRoute roles={['ADMIN']} showError={true}><AMPIMigration /></PrivateRoute>} />
        <Route path='/ampi-migration-v2' element={<PrivateRoute roles={['ADMIN']} showError={true}><AMPIMigrationOptimized /></PrivateRoute>} />
        <Route path='/ampi-migration-optimized' element={<PrivateRoute roles={['ADMIN']} showError={true}><AMPIMigrationOptimized /></PrivateRoute>} />
        <Route path='/migracion-optimizada' element={<PrivateRoute roles={['ADMIN']} showError={true}><MigracionOptimizada /></PrivateRoute>} />
        <Route path='/correccion-propiedades' element={<PrivateRoute roles={['ADMIN']} showError={true}><CorreccionPropiedades /></PrivateRoute>} />
        <Route path='/analizar-grupos-propiedades' element={<PrivateRoute roles={['ADMIN']} showError={true}><AnalizarGruposPropiedades /></PrivateRoute>} />
        <Route path='/eliminar-propiedades-duplicadas' element={<PrivateRoute roles={['ADMIN']} showError={true}><EliminarPropiedadesDuplicadas /></PrivateRoute>} />
        <Route path='/agregar-campo-tipo' element={<PrivateRoute roles={['ADMIN']} showError={true}><AgregarCampoTipo /></PrivateRoute>} />
        <Route path='/database-analysis' element={<PrivateRoute roles={['ADMIN']} showError={true}><DatabaseAnalysis /></PrivateRoute>} />
        <Route path='/database-cleanup' element={<PrivateRoute roles={['ADMIN']} showError={true}><DatabaseCleanup /></PrivateRoute>} />
        <Route path='/integrity-validator' element={<PrivateRoute roles={['ADMIN']} showError={true}><IntegrityValidator /></PrivateRoute>} />
        <Route path='/migration-status' element={<PrivateRoute roles={['ADMIN']} showError={true}><MigrationResume /></PrivateRoute>} />
        <Route path='/migration-resume' element={<PrivateRoute roles={['ADMIN']} showError={true}><MigrationResume /></PrivateRoute>} />
        <Route path='/property-data-checker' element={<PrivateRoute roles={['ADMIN']} showError={true}><PropertyDataChecker /></PrivateRoute>} />
        <Route path='/property-linker' element={<PrivateRoute roles={['ADMIN']} showError={true}><PropertyLinker /></PrivateRoute>} />
        <Route path='/admin-password-reset-manager' element={<PrivateRoute roles={['ADMIN']} showError={true}><PasswordResetManager /></PrivateRoute>} />
        <Route path='/admin-property-assignment-tools' element={<PrivateRoute roles={['ADMIN']} showError={true}><PropertyAssignmentManager propertyId="" /></PrivateRoute>} />
        <Route path='/admin-data-sync-analyzer' element={<PrivateRoute roles={['ADMIN']} showError={true}><DataSyncAnalyzer /></PrivateRoute>} />
        <Route path='/admin-property-analyzer' element={<PrivateRoute roles={['ADMIN']} showError={true}><PropertyAnalyzer /></PrivateRoute>} />
        <Route path='/admin-fix-firebase-accounts' element={<PrivateRoute roles={['ADMIN']} showError={true}><FixFirebaseAccounts /></PrivateRoute>} />
        <Route path='/admin-fix-firebase-accounts-batch' element={<PrivateRoute roles={['ADMIN']} showError={true}><FixFirebaseAccountsBatch /></PrivateRoute>} />
        <Route path='/admin-fix-missing-firestore-users' element={<PrivateRoute roles={['ADMIN']} showError={true}><FixMissingFirestoreUsers /></PrivateRoute>} />
        <Route path='/admin-asignar-propiedades-miriam' element={<PrivateRoute roles={['ADMIN']} showError={true}><AsignarPropiedadesMiriam /></PrivateRoute>} />
        <Route path='/admin-asignacion-masiva-propiedades' element={<PrivateRoute roles={['ADMIN']} showError={true}><AsignacionMasivaPropiedades /></PrivateRoute>} />
        <Route path='/admin-diagnostico-propiedades' element={<PrivateRoute roles={['ADMIN']} showError={true}><DiagnosticoPropiedades /></PrivateRoute>} />
        <Route path='/admin-actualizar-nombres-flex' element={<PrivateRoute roles={['ADMIN']} showError={true}><ActualizarNombresFlex /></PrivateRoute>} />
        <Route path='/admin-reporte-asignaciones' element={<PrivateRoute roles={['ADMIN']} showError={true}><ReporteAsignaciones /></PrivateRoute>} />
        <Route path='/admin-property-cleanup' element={<PrivateRoute roles={['ADMIN']} showError={true}><PropertyCleanupManager /></PrivateRoute>} />
        <Route path='/admin-property-manual-linker' element={<PrivateRoute roles={['ADMIN']} showError={true}><PropertyManualLinker /></PrivateRoute>} />
        <Route path='/admin-property-agency-assigner' element={<PrivateRoute roles={['ADMIN']} showError={true}><PropertyAgencyAssignerPage /></PrivateRoute>} />
        {/* <Route path='/migration-audit' element={<MigrationAudit />} /> */}
        <Route path='/list-layout-one' element={<ListLayoutOne/>}/>
        <Route path='/list-layout-two' element={<ListLayoutTwo/>}/>
        <Route path='/list-layout-three' element={<ListLayoutThree/>}/>
        <Route path='/list-layout-with-map' element={<ListLayoutWithMap/>}/>
        <Route path='/list-layout-full' element={<ListLayoutFull/>}/>
        <Route path='/grid-layout-with-sidebar' element={<GridLayoutWithSidebar/>}/>
        <Route path='/classical-layout-with-sidebar' element={<ClassicalLayoutWithSidebar/>}/>
        <Route path='/grid-layout-with-map' element={<GridLayoutWithMap/>}/>
        <Route path='/grid' element={<Grid/>}/>
        <Route path='/classical-property' element={<ClassicalProperty/>}/>
        <Route path='/classical-layout-with-map' element={<ClassicalLayoutWithMap/>}/>
        <Route path='/half-map' element={<HalfMap/>}/>
        <Route path='/half-map-2' element={<HalfMapTwo/>}/>
        <Route path='/single-property-1' element={<SinglePropertyOne/>}/>
        <Route path='/single-property-1/:id' element={<SinglePropertyOne/>}/>
        <Route path='/view-property/:id' element={<SinglePropertyOne/>}/>
        <Route path='/edit-property/:id' element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} showError={true}>
            <EditProperty/>
          </PrivateRoute>
        }/>
        <Route path='/single-property-2' element={<Navigate to='/single-property-1' replace/>}/>
        <Route path='/single-property-2/:id' element={<Navigate to='/single-property-1' replace/>}/>
        <Route path='/single-property-3' element={<Navigate to='/single-property-1' replace/>}/>
        <Route path='/single-property-3/:id' element={<Navigate to='/single-property-1' replace/>}/>
        <Route path='/single-property-4' element={<Navigate to='/single-property-1' replace/>}/>
        <Route path='/single-property-4/:id' element={<Navigate to='/single-property-1' replace/>}/>
        <Route path='/agents' element={<Agents/>}/>
        <Route path='/agent-page' element={<AgentPage/>}/>
        <Route path='/agent-page/:id' element={<AgentPage/>}/>
        <Route path='/agencies' element={<Agencies/>}/>
        <Route path='/agency-page' element={<AgencyPage/>}/>
        <Route path='/agency-page/:id' element={<AgencyPage/>}/>
        {/* Sprint 0 (F0-005): alta de agente/inm/asociado requiere ADMIN o ASOCIADO */}
        <Route path='/add-agent' element={<PrivateRoute roles={['ADMIN','ASOCIADO']} showError={true}><AddAgent/></PrivateRoute>}/>
        <Route path='/add-inm' element={<PrivateRoute roles={['ADMIN']} showError={true}><AddInm/></PrivateRoute>}/>
        <Route path='/add-aso' element={<PrivateRoute roles={['ADMIN']} showError={true}><AddAso/></PrivateRoute>}/>
        <Route path='/dashboard' element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} permission="access-dashboard" showError={true}>
            <Dashboard/>
          </PrivateRoute>
        }/>
        <Route path='/payment' element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} showError={true}>
            <Payment/>
          </PrivateRoute>
        }/>
        <Route path='/my-profile' element={
          <PrivateRoute roles={['ASOCIADO', 'AFILIADO']} permission="edit-profile" showError={true}>
            <MyProfile/>
          </PrivateRoute>
        }/>
        <Route path='/my-property' element={
          <PrivateRoute roles={['ASOCIADO', 'AFILIADO']} permission="view-my-properties" showError={true}>
            <MyProperty/>
          </PrivateRoute>
        }/>
        <Route path='/my-project' element={
          <PrivateRoute roles={['ASOCIADO', 'AFILIADO']} permission="view-my-projects" showError={true}>
            <MyProject/>
          </PrivateRoute>
        }/>
        <Route path='/mis-cursos' element={
          <PrivateRoute roles={['ASOCIADO', 'AFILIADO']} showError={true}>
            <MisCursos/>
          </PrivateRoute>
        }/>
        <Route path='/mis-leads' element={
          <PrivateRoute roles={['ASOCIADO', 'AFILIADO']} showError={true}>
            <MisLeads/>
          </PrivateRoute>
        }/>
        <Route path='/bookmark-list' element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} showError={true}>
            <BookmarkList/>
          </PrivateRoute>
        }/>
        <Route path='/change-password' element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} allowAdminComite={true} showError={true}>
            <ChangePassword/>
          </PrivateRoute>
        }/>
        <Route path='/compare-property' element={<CompareProperty/>}/>
        <Route path='/submit-property' element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="create-property" showError={true}>
            <SubmitProperty/>
          </PrivateRoute>
        }/>
        <Route path='/submit-project' element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} showError={true}>
            <SubmitProject/>
          </PrivateRoute>
        }/>
        <Route path='/blog' element={<Blog/>}/>
        <Route path='/blog-detail' element={<BlogDetail/>}/>
        <Route path='/blog-detail/:id' element={<BlogDetail/>}/>
        {/* Sprint 6 (F1-016): ruta de demo del template Resido — solo en dev */}
        <Route path='/component' element={process.env.NODE_ENV === 'development' ? <Component/> : <Navigate to='/' replace />}/>
        {/* Sprint 6 (F1-005): /pricing es placeholder EN del template Resido — solo en dev */}
        <Route path='/pricing' element={process.env.NODE_ENV === 'development' ? <Pricing/> : <Navigate to='/' replace />}/>
        <Route path='/404' element={<Error/>}/>
        <Route path='/contact' element={<Contact/>}/>
        <Route path='/about-us' element={<AboutUs/>}/>
        <Route path='/beneficios' element={<Beneficios/>}/>
        <Route path='/zonas' element={<Zonas/>}/>
        <Route path='/zonas/:slug' element={<ZonaDetail/>}/>
        <Route path='/certificacion' element={<Certificacion/>}/>
        <Route path='/checkout' element={<Checkout/>}/>
        <Route path='/create-account' element={<CreateAccount/>}/>
        <Route path='/admin-create-taller' element={
          <PrivateRoute roles={['ADMIN']} permission="create-course" showError={true} allowAdminComite={true}>
            <CreateTaller/>
          </PrivateRoute>
        }/>
        <Route path='/place-search' element={<HalfMapTwo/>}/>
        <Route path='/submit-property-dashboard' element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="create-property" showError={true}>
            <SubmitPropertyDashboard/>
          </PrivateRoute>
        }/>
        <Route path='/calificacion' element={<Calificacion/>}/>
        <Route path='/asociados' element={<Asociados/>}/>
        <Route path='/asociado-page' element={<AsociadoPage/>}/>
        <Route path="/asociado-page/:id" element={<AsociadoPage />} />
        <Route path="/ver-taller" element={<VerTalleres />} />
        <Route path="/admin-talleres" element={
          <PrivateRoute roles={['ADMIN']} permission="manage-all-courses" showError={true} allowAdminComite={true}>
            <AdminTalleres />
          </PrivateRoute>
        } />
        <Route path="/edit-taller/:id" element={
          <PrivateRoute roles={['ADMIN']} permission="edit-course" showError={true} allowAdminComite={true}>
            <EditTaller />
          </PrivateRoute>
        } />
        <Route path="/ver-taller-ind/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} permission="view-course" showError={true} allowAdminComite={true}>
            <VerTallerInd />
          </PrivateRoute>
        } />
        <Route path="/edit-inmobiliaria/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} showError={true}>
            <EditInmobiliaria />
          </PrivateRoute>
        } />
        <Route path="/project-list" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} permission="view-my-projects" showError={true}>
            <ProjectList />
          </PrivateRoute>
        } />
        <Route path="/view-project/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} permission="view-project" showError={true}>
            <ViewProject />
          </PrivateRoute>
        } />
        <Route path="/my-project" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="view-my-projects" showError={true}>
            <MyProject />
          </PrivateRoute>
        } />
        <Route path="/view-property/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} permission="manage-property" showError={true}>
            <ViewProperty />
          </PrivateRoute>
        } />
        <Route path="/aprobar-propiedades" element={
          <PrivateRoute roles={['ADMIN']} permission="approve-properties" showError={true}>
            <AprobarPropiedades />
          </PrivateRoute>
        } />
        <Route path="/mis-cursos" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} permission="view-courses" showError={true}>
            <MisCursos />
          </PrivateRoute>
        } />
        <Route path="/escanear-asistencia" element={
          <PrivateRoute roles={['ADMIN']} permission="scan-attendance" showError={true} allowAdminComite={true}>
            <ScannAsistenia />
          </PrivateRoute>
        } />
        <Route path="/admin-dashboard" element={
          <PrivateRoute roles={['ADMIN']} showError={true}>
            <AdminDashboard />
          </PrivateRoute>
        } />
        <Route path="/aprobar-resena" element={
          <PrivateRoute roles={['ADMIN']} permission="approve-reviews" showError={true}>
            <AprobarResena />
          </PrivateRoute>
        } />
        <Route path="/admin-inm" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="manage-all-agencies" showError={true}>
            <AdminInm />
          </PrivateRoute>
        } />
        <Route path="/ver-inm/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="edit-agency" showError={true}>
            <VerInm />
          </PrivateRoute>
        } />
        <Route path="/add-admin" element={
          <PrivateRoute roles={['ADMIN']} showError={true}>
            <AddAdmin />
          </PrivateRoute>
        } />
        <Route path="/admin-project" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="manage-all-projects" showError={true}>
            <AdminProject />
          </PrivateRoute>
        } />
        <Route path="/ver-project/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="view-project" showError={true}>
            <VerProject />
          </PrivateRoute>
        } />
        <Route path="/edit-project/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="edit-projects" showError={true}>
            <EditProject />
          </PrivateRoute>
        } />
        <Route path="/admin-property" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="manage-all-properties" showError={true}>
            <AdminProperty />
          </PrivateRoute>
        } />
        <Route path="/view-admin-property/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO', 'AFILIADO']} permission="manage-property" showError={true}>
            <ViewAdminProperty />
          </PrivateRoute>
        } />
        {/* Sprint 0 (F3-001): AFILIADO removido - solo ADMIN y ASOCIADO pueden editar propiedades */}
        <Route path="/edit-property/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="edit-property" showError={true}>
            <EditProperty />
          </PrivateRoute>
        } />
        <Route path="/admin-afiliado" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="manage-all-affiliates" showError={true}>
            <AdminAfiliado />
          </PrivateRoute>
        } />
        <Route path="/edit-agent/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} permission="create-affiliate" showError={true}>
            <EditAgent />
          </PrivateRoute>
        } />
        <Route path="/ver-admin-afiliado/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} showError={true}>
            <VerAdminAfiliado />
          </PrivateRoute>
        } />
        <Route path="/editar-afiliado/:id" element={
          <PrivateRoute roles={['ADMIN', 'ASOCIADO']} showError={true}>
            <EditarAfiliado />
          </PrivateRoute>
        } />
        <Route path="/admin-asociado" element={
          <PrivateRoute roles={['ADMIN']} permission="manage-all-associates" showError={true}>
            <AdminAsociado />
          </PrivateRoute>
        } />
        <Route path="/ver-admin-asociado/:id" element={
          <PrivateRoute roles={['ADMIN']} showError={true}>
            <VerAdminAsociado />
          </PrivateRoute>
        } />
        {/* Sprint 0 (F4-001): ASOCIADO removido - solo ADMIN puede editar asociados.
            Prevenía que un ASOCIADO modificara otros ASOCIADOS cross-tenant. */}
        <Route path="/editar-asociado/:id" element={
          <PrivateRoute roles={['ADMIN']} showError={true}>
            <EditarAsociado />
          </PrivateRoute>
        } />
        <Route path="/admin-asignaciones" element={
          <PrivateRoute roles={['ADMIN']} permission="manage-assignments" showError={true}>
            <AdminAsignaciones />
          </PrivateRoute>
        } />
        <Route path="/ins-taller" element={<InscripcionCurso />} />
        <Route path="/ins-taller/:tallerId" element={<InscripcionCurso />} />
        <Route path="/inscripcion-publica" element={<InscripcionCursoPublico />} />

        {/* Sprint 0 (F0-002, F0-004, F6-001, F6-002): protección de rutas comité */}
        <Route path="/seleccionar-rol" element={
          <PrivateRoute roles={['ADMIN','ASOCIADO','AFILIADO']} showError={true} allowAdminComite={true}>
            <SeleccionarRol />
          </PrivateRoute>
        } />
        <Route path="/admin-comite/dashboard" element={
          <PrivateRoute roles={['ADMIN']} showError={true} allowAdminComite={true}>
            <AdminComiteDashboard />
          </PrivateRoute>
        } />

        {/* Sprint 0 (F0-003, F6-003): /create-taller duplicada — redirige a la versión protegida */}
        <Route path="/create-taller" element={<Navigate to="/admin-create-taller" replace />} />

        {/* Herramienta de verificación de inmobiliarias nuevas */}
        <Route path="/verificar-inmobiliarias-nuevas" element={
          <PrivateRoute roles={['ADMIN']} showError={true}>
            <VerificarInmobiliariasNuevas />
          </PrivateRoute>
        } />

        {/* Herramienta de migración de nuevos miembros */}
        <Route path="/migrar-nuevos-miembros" element={
          <PrivateRoute roles={['ADMIN']} showError={true}>
            <MigrarNuevosMiembros />
          </PrivateRoute>
        } />

        {/* Padrón oficial de miembros */}
        <Route path="/admin-padron-oficial" element={
          <PrivateRoute roles={['ADMIN']} showError={true}>
            <PadronMiembrosOficiales />
          </PrivateRoute>
        } />

        {/* Lista oficial de miembros */}
        <Route path="/admin-lista-oficial" element={
          <PrivateRoute roles={['ADMIN']} showError={true}>
            <ListaOficialMiembros />
          </PrivateRoute>
        } />

        {/* Reconciliar miembros faltantes */}
        <Route path="/admin-reconciliar-miembros" element={
          <PrivateRoute roles={['ADMIN']} showError={true}>
            <ReconciliarMiembros />
          </PrivateRoute>
        } />

        {/* Reconciliar agencias desde CSV */}
        <Route path="/admin-reconciliar-agencias" element={
          <PrivateRoute roles={['ADMIN']} showError={true}>
            <ReconciliarAgenciasCsv />
          </PrivateRoute>
        } />

        {/* Reubicar miembros */}
        <Route path="/admin-reubicar-miembros" element={
          <PrivateRoute roles={['ADMIN']} showError={true}>
            <ReubicarMiembros />
          </PrivateRoute>
        } />

        {/* Limpiar duplicados */}
        <Route path="/admin-limpiar-duplicados" element={
          <PrivateRoute roles={['ADMIN']} showError={true}>
            <LimpiarDuplicados />
          </PrivateRoute>
        } />

        {/* Dashboard de sincronización MLS */}
        <Route path="/admin-mls-sync" element={
          <PrivateRoute roles={['ADMIN']} showError={true}>
            <MLSSyncDashboard />
          </PrivateRoute>
        } />

        {/* Centro de Ayuda - Rutas públicas */}
        <Route path="/ayuda" element={<HelpCenter />} />
        <Route path="/ayuda/seccion/:sectionId" element={<HelpSection />} />
        <Route path="/ayuda/articulo/:articleId" element={<HelpArticle />} />
        <Route path="/ayuda/faq" element={<HelpFAQ />} />
        <Route path="/ayuda/glosario" element={<HelpGlossary />} />

      </Routes>
      </main>


        </UserProvider>
      </ErrorBoundary>
      <ScrollToTop />
    </>
  );
}

export default App;
